import { isEmpty } from '@sgme/fp';
import type { ColDef, HeaderValueGetterFunc, HeaderValueGetterParams } from 'ag-grid-community';
import { useSPIntl } from 'hooks/useIntl';
import type { IntlKey } from 'locales';
import { useCallback } from 'react';

export function useHeaderValueGetter(getHeaderIntlKey: (columnName: string) => IntlKey) {
  const { formatMessage } = useSPIntl();
  const headerValueGetter: HeaderValueGetterFunc = useCallback(
    (params: HeaderValueGetterParams) => {
      const columnDefinition = params.colDef as ColDef;
      const key = columnDefinition.headerName ?? columnDefinition.field;
      if (isEmpty(key)) {
        return '';
      }
      const localizationId = getHeaderIntlKey(key);
      return (
        formatMessage({
          id: localizationId,
          defaultMessage: key,
        }) ?? key
      );
    },
    [formatMessage, getHeaderIntlKey],
  );
  return headerValueGetter;
}
